import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action, get } from '@ember/object';
import { inject } from '@ember/service';
import { guidFor } from '@ember/object/internals';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<select\n  disabled={{@disabled}}\n  id={{this._selectId}}\n  {{on \'change\' this.change}}>\n\n  {{#if @prompt}}\n    <option selected={{not this.selection}}>\n      {{@prompt}}\n    </option>\n  {{/if}}\n\n  {{#each @content key=\"@identity\" as |sItem|}}\n    {{#if @isSingleArray}}\n      <option value=\"{{sItem}}\" selected={{is-equal sItem this.selection}}>\n        {{sItem}}\n      </option>\n    {{else if @isBelongsTo}}\n      <option value=\"{{read-path sItem (or @optionValuePath \"id\")}}\"\n          selected={{is-equal (read-path sItem (or @optionValuePath \"id\")) this.selection}}>\n        {{read-path sItem @optionLabelPath}}\n      </option>\n    {{else}}\n      <option value=\"{{read-path sItem @optionValuePath}}\"\n          selected={{is-equal (read-path sItem @optionValuePath) this.selection}}>\n        {{read-path sItem @optionLabelPath}}\n      </option>\n    {{/if}}\n  {{/each}}\n</select>\n");

var _class, _descriptor;
let BbSelectComponent = (_class = class BbSelectComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    this._selectId = `select-${guidFor(this)}`;
  }
  get selection() {
    const sel = this.args.selection;

    // Se @selection è un oggetto (belongs-to o record), estrai lo scalare per
    // il confronto nel template: usa optionValuePath se fornito, altrimenti 'id'.
    // Così this.selection è sempre confrontabile con il value-path delle option.
    if (sel != null && typeof sel === 'object') {
      return get(sel, this.args.optionValuePath || 'id');
    }
    return sel;
  }
  change(event) {
    const selectEl = event.target;
    const selectedIndex = selectEl.selectedIndex;
    const content = this.args.content;
    if (!content) return;
    const hasPrompt = !!this.args.prompt;
    const contentIndex = hasPrompt ? selectedIndex - 1 : selectedIndex;
    if (contentIndex < 0) {
      this.args.action?.(null);
      this.args.returnAction?.(null);
      return;
    }
    let selection = content[contentIndex];
    if (this.args.isBelongsTo) {
      const recordId = selectEl.value || selection?.id;
      selection = this.store.peekRecord(this.args.relatedModelType, recordId);
      if (this.args.parentModel) {
        // Forza dirty tracking sul modello padre
        this.args.parentModel.my_dirty = !this.args.parentModel.my_dirty;
      }
    }
    if (typeof this.args.action === 'function') {
      this.args.action(selection);
    }
    if (typeof this.args.returnAction === 'function') {
      this.args.returnAction(selection);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "change", [action], Object.getOwnPropertyDescriptor(_class.prototype, "change"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbSelectComponent);

export { BbSelectComponent as default };
//# sourceMappingURL=bb-select.js.map
